import React from 'react';

const AssignmentSelectorContext = React.createContext();

export default AssignmentSelectorContext;
